<template>

  <accordion-simple-item title="Template" :flex="true" v-if="userData?.isAdmin">
    <div class="flex flex-grow flex-col overflow-hidden h-full">
      <TRInput v-model="templateGroupSearch" type="text" placeholder="Kategorie suchen..."
               class="p-2 w-full my-2"></TRInput>
      <div class="overflow-auto ">
        <div v-for="templateGroup in filteredPageTemplateGroups" :key="templateGroup.idPageTemplateGroup"
             class=" cursor-pointer w-full ">
          <div class="w-full  flex my-2 " :data-ui="'template-group-' + templateGroup.name "
               :class="{ 'bg-trader-blue text-white': activeTemplateGroupId == templateGroup.idPageTemplateGroup, 'bg-trader-dark-gray': activeTemplateGroupId != templateGroup.idPageTemplateGroup }"
               @click="showTemplates(templateGroup.idPageTemplateGroup)">
                  <span class="w-full h-full p-1 ">
                  {{ templateGroup.name }}
                  </span>
          </div>

          <div v-if="templateGroupId == templateGroup.idPageTemplateGroup">
            <div v-for="template in pageTemplates" :key="template.pageTemplateId">
              <div class="w-full p-1 hover:bg-trader-blue hover:text-white flex ml-2 mb-2" :data-ui="'template-' + template.name "
                   @click="navigateTo(`/administration/${accordionIndex}/template`, {templateGroupId:templateGroupId,  templateId: template.pageTemplateId})"
                   :class="{ 'bg-trader-blue text-white': templateId == template.pageTemplateId, 'bg-trader-gray': templateId != template.pageTemplateId}">
                <span class="hover:underline">{{ template.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </accordion-simple-item>
</template>


<script>
import TRInput from "@/components/Base/TRInput.vue";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import router from "@/router";
import SignalBus from "@/application/SignalBus";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";

export default {
  name: "STemplate",
  data() {
    return {
      templateGroupSearch: '',
      templateGroupId: null,
      activeTemplateGroupId: 0,
      templateId: 0,
      pageTemplates: [],
      pageTemplateGroups: [],
    }
  },
  components: {
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  props: {
    accordionIndex: {
      type: Number,
      default: () => {
      }
    },
  },
  computed: {
    ...mapState('user', ['userData']),
    filteredPageTemplateGroups() {
      return this.pageTemplateGroups.filter(templateGroup => templateGroup.name.toLowerCase().includes(this.templateGroupSearch.toLowerCase()));
    },
  },
  methods: {
    async getPageTemplateGroups() {
      try {
        const response = await apolloClient.query({
          query: gql`
        query getPageTemplateGroups {
          getPageTemplateGroups(magazinId: 0) {
            idPageTemplateGroup
            name
          }
        }
      `,
        });

        this.pageTemplateGroups = response.data.getPageTemplateGroups

      } catch (error) {
        console.error("Fehler beim Abrufen der pageTemplateGroups:", error);

      }
    },
    async getPageTemplates(articleTemplateGroupId) {
      try {
        const response = await apolloClient.query({
          query: gql`
        query getPageTemplates($articleTemplateGroupId: Int!) {
          getPageTemplates( articleTemplateGroupId: $articleTemplateGroupId) {
            pageTemplateId
            name
            groupId
          }
        }
      `,
          variables: {
            articleTemplateGroupId: articleTemplateGroupId
          }
        });

        this.pageTemplates = response.data.getPageTemplates
        this.pageTemplates.forEach(pageTemplate => {
          if (pageTemplate.pageTemplateId === this.templateId) {
            this.selectedTemplateId = pageTemplate.pageTemplateId
          }
        });

      } catch (error) {
        console.error("Fehler beim Abrufen der pageTemplates:", error);
      }
    },
    showTemplates(templateGroupId) {
      this.selectedTemplateGroupId = this.selectedTemplateGroupId === templateGroupId ? null : templateGroupId;
      this.getPageTemplates(templateGroupId);
      this.templateGroupId = templateGroupId;
    },
    navigateTo(route, params = {}) {
      let path = route;
      if (Object.keys(params).length) {
        const paramParts = Object.keys(params).map(key => params[key]);
        path += '/' + paramParts.join('/');
      }
      router.push(path);
      if (route.includes('template')) {
        this.pageTemplateId = params.templateId;
      }
    },

  },
  mounted() {
    this.getPageTemplateGroups();
  },
  created() {
    this.templateId = this.$route.params.templateId
    this.activeTemplateGroupId = this.$route.params.templateGroupId
  },
  watch: {
    '$route.params.templateId': function (newId, oldId) {
      this.templateId = newId;
    },
    '$route.params.templateGroupId': function (newId, oldId) {
      this.activeTemplateGroupId = newId;
    },
  },
}
</script>